import { SEVERITY_OPTIONS } from 'src/apps/mobile-sdk/pages/all-tesks/sections/header/MobileSdkTestsFilterDefinitions';
import { TMobileSdkTestFilterOptions } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { orderByMethod } from 'src/common/helpers/DataFilterHelper';
import { formatFilterOptionsForEvSelect } from 'src/common/helpers/FormatHelper';

import { MobileSdkTestFilterOptionsQuery } from '../MobileSdkTestFilterOptions.generated';

export const transformMobileSdkTestFilterOptionsResults = (
	rawResults: MobileSdkTestFilterOptionsQuery
): TMobileSdkTestFilterOptions => {
	const {
		type_name_group_uniq_array: typeResults = [],
		scan_name_group_uniq_array: scanResults = []
	} = rawResults?.filter_groups?.[0] ?? {};

	return {
		severities: SEVERITY_OPTIONS,
		types: formatFilterOptionsForEvSelect(orderByMethod(typeResults.filter((type) => type))),
		scans: formatFilterOptionsForEvSelect(orderByMethod(scanResults.filter((scan) => scan)))
	};
};
